var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5H2.5V2H1C0.447715 2 0 2.50368 0 3.125V14.375C0 14.9963 0.447715 15.5 1 15.5H7C7.55228 15.5 8 14.9963 8 14.375V3.125C8 2.50368 7.55228 2 7 2H5.5V0.5Z",
    fill: "#D8DBE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17902e-06 8.5C-1.48833e-06 9.08333 1.46004e-07 13.8667 1.46004e-07 14.45C1.46004e-07 15.0299 0.447715 15.5 1 15.5H7C7.55228 15.5 8 15.0299 8 14.45C8 13.8667 8 9.08333 8 8.5H6.17902e-06Z",
    fill: "#0A1F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.133b25634e71b0d57ef5fdc49c9ad59f.svg";
export { ForwardRef as ReactComponent };